var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_c('span',{staticClass:"indiHolder"},[_c('div',{staticClass:"indicator"},[_c('div'),_c('div'),_c('div'),_c('div')]),_c('div',{staticClass:"shadow"},[_c('div'),_c('div'),_c('div'),_c('div')])])])])
}]

export { render, staticRenderFns }